import { CContainer } from "@coreui/react";
import Cards from "@webkit/components/Cards.js";
import { FC, useContext, useEffect } from "react";
import { CreditsContext } from "@utils/GlobalContext.js"; 
import AppImage from "@assets/images/crea.jpg";
import AppListImage from "@assets/images/edit.jpg";
import PriceImage from "@assets/images/payment.png";
import { t } from 'i18next';

const Home: FC<any> = ({ route }) => {
  const creditsCtx = useContext(CreditsContext); 
  const cardItems = [
    {
      name: t('card.button'),
      title: t('card.title_first_card'),
      text: t('card.subtitle_first_card'),
      image: AppImage,
      to: "/new-app"
    },
    {
      name: t('card.button'),
      text: t('card.subtitle_second_card'),
      title:  t('card.title_second_card'),
      image: AppListImage,
      to: "/apps"
    },
    {
       name: t('card.button'),
       text: t('card.subtitle_third_card'),
       title:  t('card.title_third_card'),
       image: PriceImage,
       to: "/prices-plans"
     },
     /* {
       name: t('card.button'),
       title:  t('card.title_third_card'),
       text: t('card.subtitle_third_card'),
       image: AnalyticsImage,
       to: "/analytics"
     } */
  ];
  
   useEffect(()=>{
    if (!creditsCtx?.refreshCredits) return;
    creditsCtx.refreshCredits();
  }, [creditsCtx?.refreshCredits]) 
  
  return (

    <div className="body flex-grow-1" >
      <CContainer className="px-2 py-6" lg>
        <h5>{t("title.welcome")}</h5>
        <p>{t("page_description.home_page")}</p>
        <Cards items={cardItems} cols={3} />
      </CContainer>
    </div>

  );
};

export default Home;
